// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "div.seo-visible-header[data-v-163ad1a8]{min-height:100vh;display:flex;flex-direction:column;justify-content:stretch}div.seo-visible-header[data-v-163ad1a8] .header-search{max-height:unset;flex:1 0}@media (max-width:767px){div.seo-visible-header[data-v-163ad1a8] .header-search .trusts{display:none}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
